import "./summersale.jpeg"
export const sliderItems = [
    {
      id: 1,
      img: "https://i.ibb.co/cXFnLLV/3.png",
      title: "SUMMER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "ffc5df",
    },
    {
      id: 2,
      img: "https://i.ibb.co/DG69bQ4/2.png",
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://i.ibb.co/cXFnLLV/3.png",
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fbf0f4",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "SHIRT STYLE!",
    },
    {
      id: 2,
      img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "LOUNGEWEAR LOVE",
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      title: "LIGHT JACKETS",
    },
  ];

  export const popularProducts = [
    {
      id: 1,
      img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
      color: "Black",
      size: "M",
      price: 25.99,
      description: "Vintage Guitar Print T-shirt for Men",
      title: "Men's Guitar Vintage Tee"
    },
    {
      id: 2,
      img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
      color: "White",
      size: "L",
      price: 19.99,
      description: "Comfortable Natural Tee for Women",
      title: "Women's Natural Tee"
    },
    {
      id: 3,
      img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
      color: "Red",
      size: "S",
      price: 299.99,
      description: "Stylish Leather Crossbody Bag for Women",
      title: "Red Leather Crossbody Bag"
    },
    {
      id: 4,
      img: "https://images.unsplash.com/photo-1552664199-fd31f7431a55?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGNsb3RoaW5nfGVufDB8fDB8fHww",
      color: "Black",
      size: "L",
      price: 49.99,
      description: "Casual Striped Shirt for Men",
      title: "Men's Striped Shirt"
    },
    {
      id: 5,
      img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
      color: "Green",
      size: "M",
      price: 29.99,
      description: "Eco-friendly Tote Bag with Creative Design",
      title: "Creative Tote Bag"
    },
    {
      id: 6,
      img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
      color: "Black",
      size: "L",
      price: 14.99,
      description: "Vintage Chill Cap with Rocket Design",
      title: "Rocket Vintage Chill Cap"
    },
    {
      id: 7,
      img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
      color: "White",
      size: "S",
      price: 199.99,
      description: "Stylish Leather Crossbody Bag for Women",
      title: "Yellow Leather Crossbody Bag"
    },
    {
      id: 8,
      img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
      color: "Black",
      size: "L",
      price: 79.99,
      description: "High-quality Women's Jacket",
      title: "Women's Fashion Jacket"
    },
    {
      id: 9,
      img: "https://images.unsplash.com/photo-1533659828870-95ee305cee3e?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIwfHx8ZW58MHx8fHx8",
      color: "Red",
      size: "M",
      price: 39.99,
      description: "Soft Cotton Hoodie for Men",
      title: "Men's Purple Cotton Hoodie"
    },
    {
      id: 10,
      img: "https://images.unsplash.com/photo-1533659828870-95ee305cee3e?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIwfHx8ZW58MHx8fHx8",
      color: "Red",
      size: "S",
      price: 34.99,
      description: "Casual Pink Dress for Women",
      title: "Women's Casual Pink Dress"
    },
    {
      id: 11,
      img: "https://media.istockphoto.com/id/960241884/photo/man-drinking-coffee.webp?b=1&s=170667a&w=0&k=20&c=ZeF3x3tTgQwOV4Y9jC0mLEBoNe0MlIldk3r0WSIC4-4=",
      color: "Green",
      size: "L",
      price: 59.99,
      description: "Stylish Leather Wallet with RFID Protection",
      title: "Green Leather RFID Wallet"
    },
    {
      id: 12,
      img: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?auto=format&fit=crop&q=80&w=1983&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      color: "Blue",
      size: "M",
      price: 44.99,
      description: "Denim Jeans for Men",
      title: "Men's Classic Blue Denim Jeans"
    },
    {
      id: 13,
      img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
      color: "Red",
      size: "L",
      price: 49.99,
      description: "Comfortable Sneakers for Men",
      title: "Men's Red Sport Sneakers"
    },
    {
      id: 14,
      img: "https://images.unsplash.com/photo-1533659828870-95ee305cee3e?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIwfHx8ZW58MHx8fHx8",
      color: "Black",
      size: "M",
      price: 19.99,
      description: "Stylish Sunglasses with UV Protection",
      title: "Yellow UV Protection Sunglasses"
    },
    {
      id: 15,
      img: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?auto=format&fit=crop&q=80&w=1983&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      color: "Black",
      size: "M",
      price: 29.99,
      description: "Casual Backpack for Everyday Use",
      title: "Black Everyday Backpack"
    },
    {
      id: 16,
      img: "https://media.istockphoto.com/id/960241884/photo/man-drinking-coffee.webp?b=1&s=170667a&w=0&k=20&c=ZeF3x3tTgQwOV4Y9jC0mLEBoNe0MlIldk3r0WSIC4-4=",
      color: "Brown",
      size: "L",
      price: 79.99,
      description: "Leather Messenger Bag for Professionals",
      title: "Brown Leather Messenger Bag"
    },
    {
      id: 17,
      img: "https://images.unsplash.com/photo-1533659828870-95ee305cee3e?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIwfHx8ZW58MHx8fHx8",
      color: "Red",
      size: "S",
      price: 54.99,
      description: "Stylish Watch with Leather Strap",
      title: "Orange Leather Strap Watch"
    },
    {
      id: 18,
      img: "https://images.unsplash.com/photo-1609357601502-0dae733e68c6?auto=format&fit=crop&q=80&w=1887&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      color: "Green",
      size: "L",
      price: 64.99,
      description: "Warm Winter Jacket for Women",
      title: "Women's Gray Winter Jacket"
    },
    {
      id: 19,
      img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
      color: "Black",
      size: "M",
      price: 25.99,
      description: "Vintage Guitar Print T-shirt for Men",
      title: "Men's Guitar Vintage Tee"
    },
    {
      id: 20,
      img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
      color: "White",
      size: "L",
      price: 19.99,
      description: "Comfortable Natural Tee for Women",
      title: "Women's Natural Tee"
    },
    {
      id: 21,
      img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
      color: "Red",
      size: "S",
      price: 299.99,
      description: "Stylish Leather Crossbody Bag for Women",
      title: "Red Leather Crossbody Bag"
    },
    {
      id: 22,
      img: "https://images.unsplash.com/photo-1552664199-fd31f7431a55?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGNsb3RoaW5nfGVufDB8fDB8fHww",
      color: "Black",
      size: "L",
      price: 49.99,
      description: "Casual Striped Shirt for Men",
      title: "Men's Striped Shirt"
    },
    {
      id: 23,
      img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
      color: "Green",
      size: "M",
      price: 29.99,
      description: "Eco-friendly Tote Bag with Creative Design",
      title: "Creative Tote Bag"
    },
    {
      id: 24,
      img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
      color: "Black",
      size: "L",
      price: 14.99,
      description: "Vintage Chill Cap with Rocket Design",
      title: "Rocket Vintage Chill Cap"
    },
    {
      id: 25,
      img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
      color: "White",
      size: "S",
      price: 199.99,
      description: "Stylish Leather Crossbody Bag for Women",
      title: "Yellow Leather Crossbody Bag"
    },
    {
      id: 26,
      img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
      color: "Black",
      size: "L",
      price: 79.99,
      description: "High-quality Women's Jacket",
      title: "Women's Fashion Jacket"
    },
    {
      id: 27,
      img: "https://images.unsplash.com/photo-1533659828870-95ee305cee3e?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIwfHx8ZW58MHx8fHx8",
      color: "Red",
      size: "M",
      price: 39.99,
      description: "Soft Cotton Hoodie for Men",
      title: "Men's Purple Cotton Hoodie"
    },
    {
      id: 28,
      img: "https://images.unsplash.com/photo-1533659828870-95ee305cee3e?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIwfHx8ZW58MHx8fHx8",
      color: "Red",
      size: "S",
      price: 34.99,
      description: "Casual Pink Dress for Women",
      title: "Women's Casual Pink Dress"
    },
    {
      id: 29,
      img: "https://media.istockphoto.com/id/960241884/photo/man-drinking-coffee.webp?b=1&s=170667a&w=0&k=20&c=ZeF3x3tTgQwOV4Y9jC0mLEBoNe0MlIldk3r0WSIC4-4=",
      color: "Green",
      size: "L",
      price: 59.99,
      description: "Stylish Leather Wallet with RFID Protection",
      title: "Green Leather RFID Wallet"
    },
    {
      id: 30,
      img: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?auto=format&fit=crop&q=80&w=1983&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      color: "Blue",
      size: "M",
      price: 44.99,
      description: "Denim Jeans for Men",
      title: "Men's Classic Blue Denim Jeans"
    },
    {
      id: 31,
      img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
      color: "Red",
      size: "L",
      price: 49.99,
      description: "Comfortable Sneakers for Men",
      title: "Men's Red Sport Sneakers"
    },
    {
      id: 32,
      img: "https://images.unsplash.com/photo-1533659828870-95ee305cee3e?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIwfHx8ZW58MHx8fHx8",
      color: "Black",
      size: "M",
      price: 19.99,
      description: "Stylish Sunglasses with UV Protection",
      title: "Yellow UV Protection Sunglasses"
    },
    {
      id: 33,
      img: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?auto=format&fit=crop&q=80&w=1983&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      color: "Black",
      size: "M",
      price: 29.99,
      description: "Casual Backpack for Everyday Use",
      title: "Black Everyday Backpack"
    },
    {
      id: 34,
      img: "https://media.istockphoto.com/id/960241884/photo/man-drinking-coffee.webp?b=1&s=170667a&w=0&k=20&c=ZeF3x3tTgQwOV4Y9jC0mLEBoNe0MlIldk3r0WSIC4-4=",
      color: "Brown",
      size: "L",
      price: 79.99,
      description: "Leather Messenger Bag for Professionals",
      title: "Brown Leather Messenger Bag"
    },
    {
      id: 35,
      img: "https://images.unsplash.com/photo-1533659828870-95ee305cee3e?auto=format&fit=crop&q=60&w=600&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDIwfHx8ZW58MHx8fHx8",
      color: "Red",
      size: "S",
      price: 54.99,
      description: "Stylish Watch with Leather Strap",
      title: "Orange Leather Strap Watch"
    },
    {
      id: 36,
      img: "https://images.unsplash.com/photo-1609357601502-0dae733e68c6?auto=format&fit=crop&q=80&w=1887&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      color: "Green",
      size: "L",
      price: 64.99,
      description: "Warm Winter Jacket for Women",
      title: "Women's Gray Winter Jacket"
    }
  
  
  ];
  